require('new_design/desktop/camps/show/apartments');
